import React from 'react'
import { Form, Switch, Table, Card } from 'antd'
import { PauseCircleFilled } from '@ant-design/icons'
import { formatPrice } from '../../common/utils'

export default function LineItem({ item, showPricingType, onIsSelectedChange }) {
  const renderItemPricingType = item => {
    return <div className="pricing-type">
      {(item.master ? 'These workareas are ' : 'This workarea is ')} using <i>{item.pricingTypeName}</i> pricing
    </div>
  }

  const renderItemOnHold = item => {
    return <div className="pause small"><PauseCircleFilled />
      {(item.master ? ' workareas ' : ' workarea ')} on hold
    </div>
  }

  const getItemColumns = (selectedItemColumns) => {
    var columns = [{
      title: 'Item',
      dataIndex: 'name',
      key: 'name',
    }]
    if(selectedItemColumns.includes('quantityAndUnits')) {
      columns.push({
        title: 'Quantity',
        dataIndex: 'quantityAndUnits',
        key: 'quantity',
        align: 'right',
      })
    }
    if(selectedItemColumns.includes('totalPrice')) {
      columns.push({
        title: 'Price',
        dataIndex: 'totalPrice',
        key: 'totalPrice',
        align: 'right',
        render: (totalPrice) => formatPrice(totalPrice),
      })
    }
    return columns
  }

  return <div className={item.isSelected ? 'workarea approved' : 'workarea inactive'}>
    <Card
      className='workarea-card' 
      style={{
        marginBottom: '10px',
        backgroundColor: 'rgba(0, 0, 0, 0.02)',
        borderRadius: '9px'}}>
      <Form.Item>
        <div className="workarea-inner">
          <Switch
            checked={item.isSelected}
            disabled={item.locked}
            className="isSelected-switch"
            onChange={(checked) => onIsSelectedChange(item.id, checked)}
          />
          <div className="name">{item.name}</div>
          {!item.isSelected && renderItemOnHold(item)}
          <div className="price">Price: {formatPrice(item.quotedPrice)}{item.pricingTypeName === 'Per Visit' && ' per visit'}</div>
        </div>
        {showPricingType && renderItemPricingType(item)}
        <div className={`description ${item.description?.includes('ql-indent') ? 'quill-rich-text' : ''}`}
          dangerouslySetInnerHTML={{
            __html: item.description
          }}
        />
        {item.items?.length > 0 &&
          <div style={{marginTop: '10px'}}>
            <Table 
              pagination={false}
              size="small"
              bordered={false}
              dataSource={item.items}
              rowKey={(_, index) => `item-${index}`}
              columns={getItemColumns(item.selectedItemColumns)}
            />
          </div>
        }
      </Form.Item>
    </Card>
  </div>
}
